import { ProcurementStatusEnum } from "@/main/services/enum/StatusProcurement";
import { useStyles } from "./styles";
import { IdName } from "@/main/models/common";
import { getTranslateByKey } from "@/main/services/utils";

interface IOrderStatusProps {
	status: IdName;
}

export function renderColorProcurementStatus(id: number) {
	switch (id) {
		case ProcurementStatusEnum.Assigned:
			return "#7c1dc9";
		case ProcurementStatusEnum.Transit:
			return "#e92761";
		case ProcurementStatusEnum.Delivered:
			return "#009999";
		case ProcurementStatusEnum.Invoiced:
			return "#0d47a1";
		case ProcurementStatusEnum.Paid:
			return "#06d032";
		case ProcurementStatusEnum.Open:
			return "#999999";
		case ProcurementStatusEnum.Manual:
			return "#FB8C00";
		case ProcurementStatusEnum.Cancelled:
			return "#ff0000";
		case ProcurementStatusEnum.PreQuote:
			return "#997950";
		case ProcurementStatusEnum.Returned:
			return "#ff0000";
		case ProcurementStatusEnum.CancelProcess:
			return "#E66565";
		case ProcurementStatusEnum.ReturnProcess:
		case ProcurementStatusEnum.ReturnApprovalProcess:
			return "#E6C565";
		case ProcurementStatusEnum.Received:
			return "#927896";
		case ProcurementStatusEnum.Transferred:
			return "#78968E";
		case ProcurementStatusEnum.WaitingRelease:
			return "#FFB300";
		case ProcurementStatusEnum.AwaitingPayment:
			return "#07654b";
		case ProcurementStatusEnum.AwaitingApproval:
			return "#ff5900ee";
		default:
			return "#000";
	}
}

export default function ProcurementStatusComponent({ status }: IOrderStatusProps) {
	const classes = useStyles();
	const objAbrevvNameStatus: Record<number, string> = {
		[ProcurementStatusEnum.Manual]: getTranslateByKey("procurementstatus.manualAbrevv"),
		[ProcurementStatusEnum.WaitingRelease]: getTranslateByKey("procurementstatus.awaitingReleaseAbrevv"),
		[ProcurementStatusEnum.ReturnProcess]: getTranslateByKey("procurementstatus.returnProcessAbrevv"),
		[ProcurementStatusEnum.ReturnApprovalProcess]: getTranslateByKey("procurementstatus.ReturnApprovalProcessAbrevv"),
		[ProcurementStatusEnum.AwaitingApproval]: getTranslateByKey("procurementStatus.awaitingApprovalAbrevv"),
	};

	return (
		<div
			className={`d-flex align-items-center justify-content-center ${classes.container}`}
			title={status.name}
			style={{ backgroundColor: renderColorProcurementStatus(status.id) }}
		>
			<span className={classes.spanContainer}>{objAbrevvNameStatus[status.id] ?? status.name}</span>
		</div>
	);
}
